export { useAgencyResource, useAgencyMutation } from '../../shared/agency/agencyHooks';

export const storeStatus = row => ['returned', 'cancelled'].includes(row.status)
  ? (row.status === 'returned' ? 'En devolución' : 'Cancelado')
  : row.picked_up_at ? 'Recogido por el cliente' : row.arrived_at ? 'Llegó a destino' : ({
    registered: 'Registrado', prepared: 'Preparado', loaded: 'En ruta a la agencia', handed_off: 'Entregado al transportista',
  }[row.status] || row.status);
export const paymentStatus = state => ({ waiting_store: 'Confirma tu disponibilidad', reported: 'Pago reportado · revisar abono',
  awaiting_payment: 'Esperando pago', unrequested: 'El cliente aún no solicita pagar', confirmed: 'Dinero recibido', not_required: 'Sin cobro al cliente',
}[state] || 'Seguimiento pendiente');
export const limaDate = value => value ? new Intl.DateTimeFormat('es-PE', { timeZone: 'America/Lima', dateStyle: 'short', timeStyle: 'short' }).format(new Date(value)) : '—';
